import { createContext, useContext } from 'react';

export const dbContext = createContext();

//Creating a new context to contain Login data - Soruce; https://reactjs.org/docs/context.html
export function useDb() {
    return useContext(dbContext);
}